/**
 * Created by pandemio on 9/23/18.
 */
import React from 'react';
import { Table} from 'reactstrap';
import { Link } from "react-router-dom";
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Class that handles the student scores by the lessons
 */
class TableTotalLessons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            modal: false,
            lessonAverageCompleteInfo: this.props.data.lessonAverageCompleteInfo,
            languages: this.props.data.languages,
            studentId: this.props.data.studentId,
            productId: this.props.data.productId
        };
        this.toggle = this.toggle.bind(this);
    }

    /**
     * Hide or shows the message window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    componentWillReceiveProps(nextProps){
        this.setState({ lessonAverageCompleteInfo: nextProps.data.lessonAverageCompleteInfo,
                languages: nextProps.data.languages,
                studentId: nextProps.data.studentId,
                productId: nextProps.data.productId},
            ()=>{
                this.mountData();
            });
    }

    mountData(){
        let lessonDetails = [];
        let lessonList = this.state.lessonAverageCompleteInfo;

        for (let i = 0; i < lessonList.length; i++) {
            // If active, add the button;
            let row;

            if(lessonList[i].Average !== null && lessonList[i].Average.length > 0) {
                row =
                    <tr key={lessonList[i].LessonId}>
                        <td>{lessonList[i].LessonTitle}</td>
                        <td>{lessonList[i].Average}</td>
                        <td>
                            <Link to={{pathname: '/report-lesson-average', state:{
                                productId: this.state.productId,
                                studentId: this.state.studentId,
                                lessonId: {value: lessonList[i].LessonId, label: lessonList[i].LessonTitle }
                            }}} className="btn btn-block btn-info">
                                <Translate id="report-student-average.see-details" options={{renderInnerHtml: false}}/>
                            </Link>
                        </td>
                    </tr>;
            }
            else
            {
                row =
                    <tr key={lessonList[i].LessonId}>
                        <td>{lessonList[i].LessonTitle}</td>
                        <td>{lessonList[i].Average}</td>
                        <td>
                            <span>
                                <Translate id="report-student-average.pending" options={{renderInnerHtml: false}}/>
                            </span>
                        </td>
                    </tr>;
            }
            lessonDetails.push(row);
        }

        this.setState({rows: lessonDetails});
    }

    /**
     * Once the component is mounted, set the lessons
     */
    componentWillMount() {
        this.mountData();
    }

    render() {

        return (
            <div>
                <Table responsive>
                    <thead>
                    <tr>
                        <th><Translate id="report-student-average.lesson" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="report-student-average.score" options={{renderInnerHtml: false}}/></th>
                        <th><Translate id="report-student-average.see-details" options={{renderInnerHtml: false}}/></th>
                    </tr>
                    </thead>
                    <tbody>
                    { this.state.rows !== "0" ? this.state.rows : null }
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default TableTotalLessons;